import { render } from "./EditMember.vue?vue&type=template&id=55257f63"
import script from "./EditMember.vue?vue&type=script&lang=js"
export * from "./EditMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__